var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m454.14 412.97c1.3906 3.7031 0.85938 7.6719-1.3242 10.715l-95.703 117.4c-1.6523 1.8516-3.8359 3.043-6.2852 3.043-2.4453 0-4.8945-1.1914-6.5469-3.043l-97.094-117.4c-2.1836-3.043-2.7109-7.0117-1.3906-10.715 1.3906-3.375 4.4297-5.8203 7.9375-5.8203h61.246v-381.55c0-5.4883 3.8359-9.7891 8.7305-9.7891h52.516c4.9609 0 8.7969 4.3008 8.7969 9.7891v381.55h61.246c3.5039 0 6.5469 2.1836 7.8711 5.8203z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.8de0dc1909ff561d16400a855356e00d.svg";
export { ForwardRef as ReactComponent };